import React from "react";
import { connect, DispatchProp } from "react-redux";
import { Page } from "../../components/page/Page";
import { PageModel } from "../../models/PageModel";
import { StoreState } from "../../models/states/StoreState";
import { Voxco } from "../../public";
import { ThemeModel } from "../../models/ThemeModel";
import { QuestionnaireModel } from "../../models/QuestionnaireModel";
import { translate } from "../../models/utilities/translationUtilities";
import { ValidationResultModel } from "../../models/ValidationResultModel";
import { getContainerDiv } from "../../utils";

interface StateProps {
    isValid: boolean;
    message: string | Error;
    validation: ValidationResultModel;
    questionnaire: QuestionnaireModel;
    isNavigationDisabled: boolean;
    page: PageModel;
    language: string;
    title: string;
    theme: ThemeModel;
    useClientValidation: boolean;
}

class PageContainerImpl extends React.PureComponent<StateProps & DispatchProp> {
    componentDidMount() {
        const { page } = this.props;
        if (page !== undefined && page.isReady) {
            this.onPageReady(page);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: StateProps) {
        const { page } = this.props;
        if (page !== nextProps.page) {
            const surveyEngine = getContainerDiv();
            if (surveyEngine !== undefined) surveyEngine.scrollTop = 0;
        }
    }

    componentDidUpdate() {
        const { page } = this.props;
        if (page !== undefined && page.isReady) {
            this.onPageReady(page);
        }
    }

    onPageReady(page: PageModel) {
        Voxco.trigger("pageReady", page);
    }

    render() {
        const { page } = this.props;
        return (
            <div role="region" aria-live="polite">
                {page?.isReady && <Page {...this.props} progress={page.progress} />}
            </div>
        );
    }
}

const mapStateToProps = (state: StoreState): StateProps => {
    const { navigation, questionnaire, validation, language, theme } = state.interview;
    const { message, disabled, currentPage } = navigation ?? {};
    return {
        message: state.isPageMessagesEnabled ? message : undefined,
        questionnaire,
        validation,
        isNavigationDisabled: disabled,
        isValid: validation.isValid,
        page: currentPage,
        language,
        theme,
        title: translate(theme, "SurveyTitle", language),
        useClientValidation: state.interview.useClientValidation,
    };
};

export const PageContainer = connect(mapStateToProps)(PageContainerImpl);
